import { environment } from '../../../../../environments/environment';

export class ProductosFitosanitariosEnvironmentDefinition {
    public showProductosNumReg = environment.features.showProductosNumReg;
    public showNPK = environment.features.showNPK;
    public showProductosFitoDosis = environment.features.showProductosFitoDosis;
    public showReto = environment.features.showReto;
    public showProductosMaxAplicacion = environment.features.showProductosMaxAplicacion;
    public showCostes = environment.features.showCostes;
    public appName = environment.appName;
    public serverUrl: string = environment.serverUrl;
    public hasClients = environment.features.hasClients;
    public showInfoCambios = environment.features.showInfoCambios;
    public showSdiProductos = environment.features.showSdiProductos;
    public canAddProductos = environment.features.canAddProductos;
    public canEditProductos = environment.features.canEditProductos;
    public canDeleteProductos = environment.features.canDeleteProductos;
}// class;